import { render } from "./HeaderNew.vue?vue&type=template&id=04c0b4a0"
import script from "./HeaderNew.vue?vue&type=script&lang=js"
export * from "./HeaderNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__